import React, { Component } from "react";
import { connect } from "react-redux";
import { Base } from "zina-dogi-react";
import { VoaFilter, VoaTable } from "../components";
import * as voa from "../redux";

export class VoaList extends Component {
    componentDidMount() {
        this.props.getVoas();
    }

    render() {
        const { voas, pagination, changePage, loading, extraProps } = this.props;
        const base_op = {
            className: "voa_list",
            // title: 'Cost package Management',
            breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "VOA Management" }],
            extraProps,
            loading
        };

        const voaTable_op = {
            list: voas,
            pagination: {
                ...pagination,
                changePage
            }
        };
        return (
            <Base {...base_op}>
                <VoaFilter onSubmit={this.onFilter} />
                <VoaTable {...voaTable_op} />
            </Base>
        );
    }

    onFilter = filters => {
        this.props.changeFilters(filters);
    };
}

const mapStateToProps = store => ({
    voas: store.voa.list,
    loading: store.voa.loading,
    loaded: store.voa.loaded,
    pagination: store.voa.pagination
});

const mapDispatchToProps = dispatch => ({
    getVoas: () => dispatch(voa.actions.getVoas()),
    changePage: page => dispatch(voa.actions.changePage(page)),
    changeFilters: filters => dispatch(voa.actions.updateFilter(filters))
});

export default connect(mapStateToProps, mapDispatchToProps)(VoaList);
